const translations = {
    droneNameFieldLabel: 'Drone Name'
};

export default translations;
